import { Injectable } from '@angular/core';
import { AppMetadataHandler } from 'app/BaseFramework/configs';
export interface UserInStorage {
    userId: string;
    firstName: string;
    email: string;
    displayName: string;
    token: string;
    oneTimePasswordFl?: boolean;
    statusCd?: string;
    typeCd?: string;
    userRoleDOList?: any;
    userObjectResp?: any;
    lastName?: string;
    baseCompanyCd?: string;

}
export interface LoginInfoInStorage {
    success: boolean;
    message: string;
    landingPage: string;
    user?: any;
}

@Injectable()
export class UserInfoService {

    public currentUserKey: string = "currentUser";
    public storage: Storage = sessionStorage; // <--- you may switch between sessionStorage or LocalStrage (only one place to change)

    constructor(private appMetadataHandler:AppMetadataHandler) { }

    //Store userinfo from session storage
    storeUserInfo(userInfoString: string) {
        this.storage.setItem(this.currentUserKey, userInfoString);
    }

    //Remove userinfo from session storage
    removeUserInfo() {
        this.storage.removeItem(this.currentUserKey);
        let userDO = this.getUserInfo();
        if (userDO && userDO.companyCurrencyCd)
            this.appMetadataHandler.companyCurrencyCd = userDO.companyCurrencyCd
    }

    //Get userinfo from session storage
    getUserInfo(): any | null {
        try {
            let userInfoString: string = this.storage.getItem(this.currentUserKey);
            if (userInfoString) {
                let userObj: any = JSON.parse(this.storage.getItem(this.currentUserKey));
                return userObj;
            }
            else {
                return null;
            }
        }
        catch (e) {
            return null;
        }
    }

    isLoggedIn(): boolean {
        return this.storage.getItem(this.currentUserKey) ? true : false;
    }

    //Get User's Display name from session storage
    getUserName(): string {
        let userObj: any = this.getUserInfo();
        if (userObj !== null) {
            return userObj.displayName || userObj.firstName
        }
        return "no-user";
    }

    getUserId(): string {
        let userObj: any = this.getUserInfo();
        if (userObj !== null) {
            return userObj.userId
        }
        return "no-user";
    }

    getStoredToken(): string | null {
        let userObj: any = this.getUserInfo();
        if (userObj !== null) {
            return userObj.token;
        }
        return null;
    }
    getUserRoleDO(): any {
        let userObj: UserInStorage = this.getUserInfo();
        let roleDOOuput
        if (userObj !== null) {
            userObj.userRoleDOList.forEach(RoleDO => {
                roleDOOuput = JSON.parse(JSON.stringify(RoleDO))
            });
        }

        return roleDOOuput
    }
}
